export const MuiButtonGroup = {
  styleOverrides: {
    root: {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
      },
    },
  },
};
